import API from '../../../../network/dashboardAPI';

export const fetchWarehouses = async (page = 1, limit = 10, filters) => {
    try {
	    const postData = {page, limit, filters};
        const response = await API.getWarehouse(postData);
        return response.json();
    } catch (error) {
        console.error("Error fetching warehouses:", error);
        return { data: [], error: error.message || "Failed to fetch warehouses" };
    }
};

export const getWarehouseById = async (id) => {
    try {
        const response = await API.getWarehouseDetailByID(id);
        return response.json();
    } catch (error) {
        console.error("Error fetching warehouse:", error);
        return { data: [], error: error.message || "Failed to fetch warehouse" };
    }
};
export const createWarehouse = async (warehouseData) => {
    try {
        const response = await API.createWarehouse(warehouseData);
        return response.json();
    } catch (error) {
        console.error("Error creating warehouses:", error);
        return { data: [], error: error.message || "Failed to create warehouses" };
    }
};
export const updateWarehouse = async (id, warehouseData) => {
    try {
        const response = await API.updateWarehouse(id, warehouseData);
        return response.json();
    } catch (error) {
        console.error("Error updating warehouses:", error);
        return { data: [], error: error.message || "Failed to update warehouses" };
    }
};
export const deleteWarehouse = async (id) => {
    try {
        const response = await API.deleteWarehouse(id);
        return response.json();
    } catch (error) {
        console.error("Error deleting warehouses:", error);
        return { data: [], error: error.message || "Failed to delete warehouses" };
    }
};